import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone',
})
export class PhonePipe implements PipeTransform {
  transform(rawNum: any): string {
    if (!rawNum) {
      return '';
    }
    rawNum = String(rawNum).trim();
    if (rawNum.length === 0) {
      return '';
    }

    rawNum = rawNum.charAt(0) !== '0' ? '0' + rawNum : '' + rawNum;

    let newStr = '';
    let i = 0;

    for (; i < Math.floor(rawNum.length / 2) - 1; i++) {
      newStr = newStr + rawNum.substring(i * 2, i * 2 + 2) + ' ';
    }

    return newStr + rawNum.substring(i * 2);
  }
}
